import CommonPicker from './common-picker.vue'
export type { CommonPickerProps } from './props'
export default CommonPicker